/**
 * Process HTML content to apply target attribute to links based on open_in_new_window setting
 */
export function processHtmlLinks(html: string | undefined, openInNewWindow: boolean = true): string {
  if (!html) return '';
  
  const target = openInNewWindow ? '_blank' : '_self';
  
  // Process all <a> tags in the HTML
  return html.replace(
    /<a\s+([^>]*?)>/gi,
    (match, attributes) => {
      // Check if target is already set
      if (/target\s*=\s*["'][^"']*["']/i.test(attributes)) {
        // Replace existing target
        const newAttributes = attributes.replace(
          /target\s*=\s*["'][^"']*["']/i,
          `target="${target}"`
        );
        return `<a ${newAttributes}>`;
      } else {
        // Add target attribute
        return `<a ${attributes} target="${target}">`;
      }
    }
  );
}

/**
 * Process HTML and also clean empty paragraphs
 */
export function processAndCleanHtml(html: string | undefined, openInNewWindow: boolean = true): string {
  if (!html) return '';

  // No longer removing empty paragraphs since CSS now handles them properly
  // Empty <p></p> tags now create visual spacing as intended

  // Process links
  return processHtmlLinks(html, openInNewWindow);
}